import { Component, OnInit, Input, Output, ElementRef, EventEmitter, ViewChild, SimpleChanges, AfterViewChecked, OnChanges, OnDestroy } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AssistanceTicket } from '../../../../models/assistanceticket';
import { AssistanceService } from '../../../../models/assistanceservice';
import { AssistanceCategory } from '../../../../models/assistance-category';
import { AssistanceProvider } from '../../../../models/assistance-provider';
import { Country } from '../../../../models/country';
import { ConfService } from '../../../../services/conf.service';
import { ApiService } from '../../../../api/api.service';
import { SelectLocationComponent } from '../../../select-location/select-location.component';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { AssistanceTicketsTypesService } from '../assistance-tickets-types.service';
import { IamService } from '../../../../services/iam.service';
import { MessageService } from 'primeng/api';
import { State } from '../../../../models/state';
import { debounceTime, startWith, Subscription, map } from 'rxjs';
import { AssistancePriceSvc } from '../../../assistances/services/assistance-price.service';
import moment from 'moment';
import { AssitanceCaseProvider } from '../../../../models/assistance-case-provider';
import { LoaderService } from 'src/app/api/loader.service';
import { User } from '../../../../models/user';
import { MeService } from '../../../../services/me.service';
import { AssistanceTicketSvc } from '../../services/assistance-ticket.service';
import { environment } from 'src/environments/environment';

import { FormControl } from '@angular/forms';


import { CatalogCacheService } from 'src/app/services/catalog-cache.service';
declare var google: any;

@Component({
    selector: 'app-assistance-reassign-view-provider',
    templateUrl: './assistance-reassign-view-provider.component.html',
    styleUrls: ['./assistance-reassign-view-provider.component.css'],
    providers: [AssistancePriceSvc, MessageService],
    standalone: false
})
export class AssistanceReassignViewProviderComponent implements OnInit, AfterViewChecked, OnChanges, OnDestroy {
  @Input() service: EventEmitter<number>;
  @Input() case_id_input: number;
  @Input() id_service: number;
  country_id = 1;
  providers_;
  Provider_new;
  creatticket = new AssistanceTicket();
  user_id = -1;
  maxScroll = 0
  hasMoreProviders = true
  text_general = '';
  @Output() ocultar = new EventEmitter<boolean>();
  @Input() grouptickets: any[] = [];
  @Input() servicegroup: any;
  @Input() showstep: boolean;
  @Input() totalCount: number;
  @Input() categories: any[] = [];
  @Input() countries: any[] = [];
  @Input() assistancecase;
  @Input() sale_canceled;
  @Input() caseLocation: any = {};
  @Input() disabled: EventEmitter<boolean>;
  @Input() disableallstep: EventEmitter<void>;
  @Output() update = new EventEmitter<AssistanceTicket>();
  @Output() cancelEvent = new EventEmitter();
  @Output() activeIndexReady: EventEmitter<number>;
  @Output() setUserProvider = new EventEmitter<boolean>();
  @Output() buca_message = new EventEmitter<any>();
  states: any[];
  reasons: any[];
  noMoreProviders= false
  reason_select;
  statesDistrict: any[];
  state_id: number = null;
  state_district_id: number = null;
  is_visible = true;
  isLoading = true
  is_confirmation_visible = false;
  page = 1
  //cartas
  @Input() titular_name: any;
  @Input() tel: any;
  @Input() tipo_servicio: any;
  @Input() usuario_asesor: any;

  // Para agregar la reassignacion de buca
  // buca
  @Input() sds_provider: boolean;
  @Input() buca_plan_service: boolean;
  @Input() sinister_plan_service: boolean;
  @Input() assistance_plan_service: any;
  new_provider_id = null;
  appointmentDate: any;
  address: string = null;

  showSeeMoreProviders = false;

  providersMap;
  ticket_service;

  editOutNetworkProvider: any = {};

  providerLocation = new EventEmitter<any>();
  mapcenter = new EventEmitter<any>();
  country_code: any = {
    country_name: '',
    country_local: '',
  };
  editcategory: AssistanceCategory;
  editservice: AssistanceService;
  editprovider: AssitanceCaseProvider;
  showProviderDialog = false;
  showProviderUserDialog = false;
  provider_id = new EventEmitter<number>();
  case_service_id = new EventEmitter<number>();
  providers_app = new EventEmitter<any>();
  provider_app = new EventEmitter<any>();
  case_id = new EventEmitter<number>();
  is_case_normal = new EventEmitter<boolean>();
  service_id: number;
  hasUsers = false;
  html = '';
  emails = '';
  programtime: any;
  images = [];
  items: MenuItem[];
  providers: any[] = [];
  providersAll: any[] = [];
  selectCountry: Country;
  selectedProviders: any[] = [];
  selectedProvidersAll: any[] = [];
  @Input() readonly = false;
  stepnumber: any;
  activeIndex = 0;
  comment = '';
  timeestimated;
  number_provider = '';
  email_provider = '';
  providertemp = '';
  namepatient = '';
  identificationnumber = '';
  description = '';
  coordinatedby = '';
  daynhour = '';
  branch = '';
  responsible = '';
  cost = '';
  activateemail = false;
  observation = '';
  showNewDialog = false;

  types: any[] = [];
  editticket: AssistanceTicket;
  selectedRow: number;
  newticket = false;
  setClickedRow: Function;
  isCalcRoadDistance = false;
  countryState: State = null;
  indexArray: any[] = [];
  fromlatitude: any;
  fromlongitude: any;
  tolatitudes: any[] = [];
  tolongitudes: any[] = [];
  latitude: any;
  longitude: any;
  iAm = null;
  cartas = false;
  fieldsRequired = {
    provider: false,
  };
  programmed = 0;
  connection = 0;
  isDisabled = false;
  subscription: Subscription;
  filter: any = {
    id: null,
  };

  assistanceSaleCar: any;

  mapOptions: any = {};
  mapOverlays: any = {};
  expand_more: boolean = false;
  idProviderSelected: number = null;
  selectedRowSite: any = {};
  siteUsers: any[] = [];

  searchProvider: string;
  @Input() flagAssignProvider: boolean = false;
  @Output() notifyAssignProviderView = new EventEmitter<boolean>();
  @ViewChild(SelectLocationComponent) locationComponent;
  isAppCase: boolean = false;
  isNormalCase: boolean = false;
  lastProviderId: number = 0;
  appUsers: any[] = [];




  @Input() inlatitude: any;
  @Input() inlongitude: any;
  //---validar latitude longitud
  have_coordinates=true;
  msgs: any[] = [];
  db: any

  polygonFilter: boolean = false;
  private currentHoveredProviderId: number | null = null;
  private providerPolygons: Map<number, google.maps.Polygon[]> = new Map();

  constructor(
    public el: ElementRef,
    public conf: ConfService,
    private api: ApiService,
    private translate: TranslateService,
    private typesService: AssistanceTicketsTypesService,
    private iam: IamService,
    private assistancePriceSvc: AssistancePriceSvc,
    private messageService: MessageService,
    private loaderService: LoaderService,
    private me: MeService,
    public ticketSvc: AssistanceTicketSvc,
    private catalogCache: CatalogCacheService
  ) {
    this.iAm = this.iam.isRole;
    this.subscription = this.typesService.getServiceID().subscribe((data) => {
      if (data.serviceid === this.editticket.service_id) {
        this.showstep = true;
        this.service_id = data.serviceid;
      }
    });

    this.activeIndexReady = new EventEmitter();
  }

  ngOnInit() {

    this.setCoordinates(this.inlatitude,this.inlongitude)

    this.api.extra
      .getAssistanceSaleCar(this.case_id_input)
      .promise()
      .then((assSaleCar) => {
        this.assistanceSaleCar = assSaleCar;
      })
      .catch((e) => {});

    this.user_id = this.getMe().id;
    this.service.subscribe((data) => {
      this.service_id = data;
      this.setCoordinates(this.inlatitude,this.inlongitude)
    });

    this.country_id = this.assistancecase.origin_country_id
      ? this.assistancecase.origin_country_id
      : this.assistancecase.country_id;

    this.mapOptions = {
      center: {
        lat: 14.590518806702539,
        lng: -90.51070153590592,
      },
      zoom: 13,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP,
      },
    };

    this.types = this.typesService.getTypes();
    this.items = [
      {
        label: this.types[0].label,
        command: (event: any) => {
          this.activeIndex = 0;
        },
      },
      {
        label: this.types[1].label,
        command: (event: any) => {
          this.activeIndex = 1;
        },
      },
      {
        label: this.types[2].label,
        command: (event: any) => {
          this.activeIndex = 2;
        },
      },
      {
        label: this.types[3].label,
        command: (event: any) => {
          this.activeIndex = 3;
        },
      },
      {
        label: 'Close Ticket',
        command: (event: any) => {
          this.activeIndex = 4;
        },
      },
    ];

    this.translateTypes();

    this.setClickedRow = function (index, provider) {
      this.selectedRow = index;
      this.selectProvider(provider);
    };

    this.editticket = new AssistanceTicket();
    this.grouptickets = this.grouptickets.filter(
      (t) =>
        t.ticket_type !== 12 &&
        t.ticket_type !== 22 &&
        t.ticket_type !== 9 &&
        t.ticket_type !== 11 &&
        t.ticket_type !== 14 && // exception
        t.ticket_type !== 15 && // exception
        t.ticket_type !== 16 && // notify to customer
        t.ticket_type !== 17 && // assign / unassign user
        t.ticket_type !== 18 &&
        t.ticket_type !== 19
    );
    this.ticket_service = this.grouptickets.filter(
      (t) => t.ticket_type == 1
    )[0];
    this.lastProviderId = this.grouptickets[0]['user']['id']
    if (this.totalCount > 0) {
      this.editticket = Object.assign({}, this.grouptickets[0]);
    }

    this.editcategory = new AssistanceCategory();
    this.editservice = new AssistanceService();
    this.editprovider = new AssitanceCaseProvider(); // new AssistanceProvider();
    this.editticket.programmed = null;
    this.isCalcRoadDistance = false;
    this.countryState = null;

    if (this.sale_canceled) this.connection = 1;
    //--lleno los proveedores
    this.initproviders();
    this.getreasons();

    this.onSelectCountry(this.country_id);
    
  }



  

  ngOnChanges(changes: SimpleChanges) {

        if (changes['inlatitude']) {
            this.setCoordinates(changes['inlatitude'].currentValue ,changes['inlongitude'].currentValue)
        }
    
      }
      
      setCoordinates(latitude,longitud){
    
        if(latitude != undefined && longitud!=null && longitud!=0){
          this.have_coordinates=true;
          this.msgs = [
            { severity: 'success', summary: '', detail: 'Geolocalización recibida' }
          ];
    
       
    
        }else{
          this.have_coordinates=false;
      
          this.msgs = [
            { severity: 'error', summary: '', detail: 'El caso no tiene ubicación' }
          ];
        }
    
    
        this.caseLocation = {
          latitude: latitude ,
          longitude: longitud,
        };
    
      }


  //---metodo para obtener la informacion del usuario logueado
  getMe(): User {
    return this.me.user;
  }

  getreasons() {
    this.catalogCache.getReassignReasons().subscribe({
      next: (d) => {
        this.reasons = d;
      },
      error: (error) => {
        console.error('Error loading reassign reasons:', error);
      }
    });
  }

  restartProviders(){
    this.providers=[]
    this.appUsers =[]
    this.page = 1
    this.providerCtrl.setValue('')
    this.initproviders()
  }
  //---nuevo metodo para llenar los proveedores
  async initproviders(): Promise<void> {
    this.loaderService.display(true);
    this.api.assistanceProvicerSites.getList(this.country_id, this.ticket_service.service_id, this.ticket_service.case_id)
    .promise()
    .then((ProvidersList)=>{
      this.providerList = ProvidersList.data
      this.filteredProviders = ProvidersList.data;
    })
    this.providerCtrl.valueChanges
      .pipe(
        debounceTime(300),
        startWith(''),
        map(value => this.filterProviders(value)) 
      )
      .subscribe(filtered => {
        this.filteredProviders = filtered;
      });
    let case_providers = await this.api.assistanceProvicerSites
      .v2get(this.country_id, this.ticket_service.service_id)
      .page(this.page)
      .filter({lat: this.caseLocation.latitude, lng: this.caseLocation.longitude, polygon_filter: this.polygonFilter})
      .promise();
    let providers_app = await this.api.assistanceProvicerSites
      .getApp(
        this.country_id,
        this.ticket_service.service_id,
        this.assistancecase.id
      )
      .promise();
    this.setProvidersFromResponse(case_providers, providers_app);
  }

onProviderSelected(selected: any) {
  if (!selected || !selected.id) return;

  this.providers = [];
  this.appUsers = [];
  this.isLoading = true;
  
  const providerId = selected.id;
  const isApp = selected.isApp || false;
  const serviceId = this.ticket_service?.service_id || 0;
  const countryId = this.country_id || 0;
  const caseId = this.ticket_service?.case_id || 0;

  this.api.assistanceProvicerSites
    .getFullProviderInfo(providerId, isApp, serviceId, countryId, caseId)
    .promise()
    .then(data => {
      this.setProvidersFromResponse(data, []);
      this.isLoading = false;
    });

}

  displayFn(provider: any): string {
  if (!provider) return '';
  return `${provider.name || ''}`.trim();
}

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngAfterViewChecked() {
    this.resetStepLine();
  }

  resetStepLine() {
    this.stepnumber =
      this.el.nativeElement.getElementsByClassName('ui-steps-number');
    const stepline =
      this.el.nativeElement.getElementsByClassName('ui-steps-item');
    let loop_temp: number;
    let loop = 0;
    loop_temp = this.editticket.ticket_type;
    switch (loop_temp) {
      case 5: {
        loop = 5;
        break;
      }
      case 7: {
        loop = 1;
        break;
      }
      case 6: {
        loop = 1;
        break;
      }
      case 8: {
        loop = 1;
        break;
      }
      default: {
        loop = loop_temp;
        break;
      }
    }

    for (let i = 0; i < loop; i++) {
      if (this.stepnumber.item(i)) {
        this.stepnumber.item(i).innerHTML = '<i class="fa fa-check">';
        stepline.item(i).classList.remove('ui-state-default');
        stepline.item(i).classList.add('ui-state-highlight');

        if (loop_temp === 5) {
          this.stepnumber.item(i).style.backgroundColor = '#5CB85C';
          stepline.item(i).style.opacity = '1';
          stepline.item(i).style.background = '#5CB85C';
        }
      }
    }
  }

  async init(): Promise<void> {
    this.selectCountry = _.cloneDeep(this.assistancecase.country);
    if (this.sale_canceled) this.connection = 1;
    this.items.forEach((item) => {
      item.disabled = true;
    });

    if (this.editticket.ticket_type) {
      if (
        this.editticket.ticket_type === 4 ||
        this.editticket.ticket_type === 5
      ) {
        if (this.editticket.ticket_type === 4) {
          this.activeIndex = 4;
        } else {
          this.activeIndex = -1;
        }
        this.activeIndexReady.emit(this.activeIndex);
        return;
      } else if (this.editticket.ticket_type === 3) {
        this.items[3].disabled = false;
        this.activeIndex = 3;
      } else if (this.editticket.ticket_type === 2) {
        if (this.editticket.provider_status === 2) {
          this.editticket.provider_status = 1;
          this.editticket.provider_id = null;
          this.editticket.provider_site_id = null;
          this.editticket.coverage_id = null;
          this.items[1].disabled = false;
          this.activeIndex = 1;
        } else {
          this.items[2].disabled = false;
          this.activeIndex = 2;
        }
      } else {
        // 6,7,8,1
        this.editticket.provider_id = null;
        this.editticket.provider_site_id = null;
        this.editticket.coverage_id = null;
        this.editticket.latitude = null;
        this.editticket.longitude = null;
        this.items[1].disabled = false;
        this.activeIndex = 1;
      }
    }

    this.activeIndexReady.emit(this.activeIndex);

    if (this.editticket.service) {
      this.editservice = this.editticket.service;
      this.editcategory = this.editticket.service.category;
      this.countryState = this.assistancecase.countryState;

      if (this.editticket.provider_id) {
        this.editprovider = new AssitanceCaseProvider();
        this.editprovider.provider_id = this.editticket.provider_id;
        this.editprovider.provider_site_id = this.editticket.provider_site_id;
        this.editprovider.coverage_id = this.editticket.coverage_id;
        this.editprovider.case_id = this.editticket.case_id;
        this.editprovider.provider = this.editticket.provider;
        this.editprovider.provider_site = this.editticket.provider_site;
        this.editprovider.coverage = this.editticket.coverage;
        console.log('ESTE 1')
        if (this.editprovider.provider.price instanceof Number) {
          this.setProviderprice(
            this.editprovider.provider,
            this.editprovider.provider_site_id,
            this.editprovider.coverage_id,
            this.editticket.service_id
          );
        }
      } else {
        // Get case providers
        this.loaderService.display(true);
        let case_providers = await this.api.assistanceProvicerSites
          .v2get(this.country_id, this.ticket_service.service_id)
          .page(this.page)
          .filter({lat: this.caseLocation.latitude, lng: this.caseLocation.longitude, polygon_filter: this.polygonFilter})
          .promise();
        let providers_app = await this.api.assistanceProvicerSites
          .getApp(
            this.country_id,
            this.ticket_service.service_id,
            this.assistancecase.id
          )
          .promise();
        this.setProvidersFromResponse(case_providers, providers_app);
      }
    }
  }

  onSetVehicleType($event) {
    if ($event == '1') {
      this.editticket.car_size = 1;
    } else if ($event == '2') {
      this.editticket.car_size = 2;
    } else if ($event == '3') {
      this.editticket.car_size = 3;
    } else {
      
    }
  }

  setMap(event) {
    this.providersMap = event.map;

    setTimeout(() => {
      // ... extend bounds
      let bounds = new google.maps.LatLngBounds();
      this.mapOverlays.forEach((marker) => {
        bounds.extend(marker.getPosition());
      });

      setTimeout(() => {
        // map will need some time to load
        this.providersMap.fitBounds(bounds); // Map object used directly
      }, 1000);
    }, 1000);
  }

  /**
   *
   * @param providers is now from provider site model
   */
  setProvidersFromResponse(providers, providers_app) {
    this.providers = Array.isArray(providers.data)
      ? JSON.parse(JSON.stringify(providers.data))
      : [];

    let appProviders = Array.isArray(providers_app.data)
      ? JSON.parse(JSON.stringify(providers_app.data))
      : [];

    this.maxScroll = providers.total / environment.providerListAmount
    this.selectedProviders = this.providers;
    if (appProviders.length > 0) {
      this.isAppCase = true;
      this.isNormalCase = providers_app.normal_case;
      this.providers = this.providers.map((provider) => {
        let finded = appProviders.find(
          (pr) => pr.provider_id == provider.provider_id
        );
        if (finded) {
          provider.users = finded.users;
        }
        return provider;
      });
      this.appUsers = appProviders;
    }

    // Markers of map
    this.mapOverlays = [];

    // Origin
    this.mapOverlays.push(
      new google.maps.Marker({
        position: {
          lat: this.caseLocation.latitude,
          lng: this.caseLocation.longitude,
        },
        title: 'Ubicacion cliente',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/location_provider22.png',
      })
    );

    let provider_site_already_in_map = [];
    this.selectedProviders.forEach((provider) => {
      if (
        provider.provider_site &&
        provider.provider_site.latitude &&
        provider.provider_site.longitude
      ) {
        if (
          provider_site_already_in_map.indexOf(provider.provider_site.id) == -1
        ) {
          this.mapOverlays.push(
            new google.maps.Marker({
              position: {
                lat: provider.provider_site.latitude,
                lng: provider.provider_site.longitude,
              },
              title: provider.provider_site.name,
              icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/location_client22.png',
            })
          );

          provider_site_already_in_map.push(provider.provider_site.id);
        }
      }
    });

    let indexofprovider = 0;
    this.indexArray = [];
    this.tolongitudes = [];
    this.tolatitudes = [];
    this.loaderService.display(false);
    let providers_coverage = {}
    this.selectedProviders.forEach((p: AssitanceCaseProvider) => {
      if (providers_coverage[p.provider.id]){
        providers_coverage[p.provider.id].push({
          "site_id": p.provider_site_id ? p.provider_site_id : null,
          "coverage_id": p.coverage_id ? p.coverage_id : null,
          "timezone": p.provider.timezone ? p.provider.timezone : null,
          "price": p.provider.price ? p.provider.price : null,
          "provider": p.provider
        })
      }
      else{
        providers_coverage[p.provider.id] = []
        providers_coverage[p.provider.id].push({
          "site_id": p.provider_site_id ? p.provider_site_id : null,
          "coverage_id": p.coverage_id ? p.coverage_id : null,
          "timezone": p.provider.timezone ? p.provider.timezone : null,
          "price": p.provider.price ? p.provider.price : null,
          "provider": p.provider
        });
      }
      // this.setProviderprice(
      //   p.provider,
      //   p.provider_site_id,
      //   p.coverage_id,
      //   this.editticket.service_id
      // );
      indexofprovider++;
    });
    this.setGroupPrice(providers_coverage)
    this.isLoading = false

  }

  /**
 *
 * @param providers is now from provider site model
 */
  addProvidersFromResponse(providers, providers_app) {
  
  const newProviders = JSON.parse(JSON.stringify(providers.data));
  const newAppProviders = JSON.parse(JSON.stringify(providers_app.data));

  // Agregar nuevos proveedores a la lista existente
  this.providers = [...this.providers, ...newProviders];
  this.selectedProviders = [...this.selectedProviders, ...newProviders];
  if (newAppProviders.length > 0) {
    this.isAppCase = true;
    this.isNormalCase = providers_app.normal_case;  
    this.providers = this.providers.map((provider) => {
      let found = newAppProviders.find(
        (pr) => pr.provider_id == provider.provider_id
        
      );
      if (found) {
        provider.users = found.users;
      }
      return provider;
    });
    // Agregar los nuevos app users (puedes ajustar lógica si no quieres duplicados)
    this.appUsers = [...(this.appUsers || []), ...newAppProviders];
  }

  // Marcadores del mapa
  let provider_site_already_in_map = this.providers.map(p => p.provider_site?.id).filter(id => !!id);
  
  newProviders.forEach((provider) => {
    if (
      provider.provider_site &&
      provider.provider_site.latitude &&
      provider.provider_site.longitude &&
      provider_site_already_in_map.indexOf(provider.provider_site.id) == -1
    ) {
      this.mapOverlays.push(
        new google.maps.Marker({
          position: {
            lat: provider.provider_site.latitude,
            lng: provider.provider_site.longitude,
          },
          title: provider.provider_site.name,
          icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/location_client22.png',
        })
      );
      provider_site_already_in_map.push(provider.provider_site.id);
    }
  });

  // Agregar ubicación del cliente si aún no está (solo la primera vez idealmente)
  if (this.mapOverlays.length === 0 || !this.mapOverlays.some(m => m.title === 'Ubicacion cliente')) {
    this.mapOverlays.push(
      new google.maps.Marker({
        position: {
          lat: this.caseLocation.latitude,
          lng: this.caseLocation.longitude,
        },
        title: 'Ubicacion cliente',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/location_provider22.png',
      })
    );
  }

  // Actualizar info de precios por proveedor
  const providers_coverage = {};
  this.selectedProviders.forEach((p: AssitanceCaseProvider) => {

    if (!providers_coverage[p.provider.id]) {
      providers_coverage[p.provider.id] = [];
    }
    providers_coverage[p.provider.id].push({
      site_id: p.provider_site_id ?? null,
      coverage_id: p.coverage_id ?? null,
      timezone: p.provider.timezone ?? null,
      price: p.provider.price ?? null,
      provider: p.provider
    });
  });
  this.setGroupPrice(providers_coverage);
}



  // addProvidersFromResponse(newProviders){
  //   this.providers.push(newProviders);
  //   console.log(this)
  //   this.selectedProvidersAll = this.providersAll;
  //   let indexofprovider = 0;
  //   let providers_coverage = {}
  //   this.selectedProviders.forEach((p: AssitanceCaseProvider) => {
  //     if (providers_coverage[p.provider.id]){
  //       providers_coverage[p.provider.id].push({
  //         "site_id": p.provider_site_id ? p.provider_site_id : null,
  //         "coverage_id": p.coverage_id ? p.coverage_id : null,
  //         "timezone": p.provider.timezone ? p.provider.timezone : null,
  //         "price": p.provider.price ? p.provider.price : null,
  //         "provider": p.provider
  //       })
  //     }
  //     else{
  //       providers_coverage[p.provider.id] = []
  //       providers_coverage[p.provider.id].push({
  //         "site_id": p.provider_site_id ? p.provider_site_id : null,
  //         "coverage_id": p.coverage_id ? p.coverage_id : null,
  //         "timezone": p.provider.timezone ? p.provider.timezone : null,
  //         "price": p.provider.price ? p.provider.price : null,
  //         "provider": p.provider
  //       })
  //       providers_coverage[p.provider.id]
  //     }

     
  //     indexofprovider++;
      
  //   }
  // );
  // this.setGroupPrice(providers_coverage)

  // this.loaderService.display(false);

  // }
  setProvidersFromResponseall(providers) {
    this.providersAll = JSON.parse(JSON.stringify(providers.data));
    

    this.selectedProvidersAll = this.providersAll;
    let indexofprovider = 0;
    let providers_coverage = {}
    this.selectedProviders.forEach((p: AssitanceCaseProvider) => {
      if (providers_coverage[p.provider.id]){
        providers_coverage[p.provider.id].push({
          "site_id": p.provider_site_id ? p.provider_site_id : null,
          "coverage_id": p.coverage_id ? p.coverage_id : null,
          "timezone": p.provider.timezone ? p.provider.timezone : null,
          "price": p.provider.price ? p.provider.price : null,
          "provider": p.provider
        })
      }
      else{
        providers_coverage[p.provider.id] = []
        providers_coverage[p.provider.id].push({
          "site_id": p.provider_site_id ? p.provider_site_id : null,
          "coverage_id": p.coverage_id ? p.coverage_id : null,
          "timezone": p.provider.timezone ? p.provider.timezone : null,
          "price": p.provider.price ? p.provider.price : null,
          "provider": p.provider
        });
      }

     
      indexofprovider++;
      
    }
  );
  this.setGroupPrice(providers_coverage)
  this.isLoading = false
  this.loaderService.display(false);
  }

  async setProviderprice(
    provider: AssistanceProvider,
    provider_site_id,
    coverage_id,
    service_id
  ): Promise<void> {
    try {
      const editprice = await this.api.assistancePricesProvidersByIdservicesById
        .get(provider.id, provider_site_id, coverage_id, service_id)
        .promise();
      const offset = provider.timezone;
      const now = new Date();
      const utcDate = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
      provider.price = this.assistancePriceSvc.calculateBasePrice(
        editprice,
        utcDate,
        false,
        offset
      );
    } catch (error) {}
  }

  async setGroupPrice(providers): Promise<void> {
    try {
      let editprice
      console.log('entro aca')
      this.api.assistancePricesProviders
        .post(providers, this.editticket.service_id)
        .promise().then( (response:any) => {
          editprice = response
          
          for (let providerKey in editprice) {
            console.log(providerKey)
            if (editprice.hasOwnProperty(providerKey)) {
              const provider = editprice[providerKey];
              const offset = provider.timezone;
              const now = new Date();
              const utcDate = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
              console.log('el if 1')
              for (let [index, Provider] of this.providers.entries()) {
                if (Provider['id'] == provider['id']) {
                    console.log('el if 2')

                    this.providers[index].provider.price = this.assistancePriceSvc.calculateBasePrice(
                        provider,
                        utcDate,
                        false,
                        offset
                    );
                }
            }        
          }
        }
      }
        )
        
    } catch (error) {
      console.error('Error al configurar precios de proveedores:', error);
    }
    this.hasMoreProviders = true
    this.isLoading = false
  }  

  async indexChange(index): Promise<void> {
    this.items.forEach((item) => {
      item.disabled = true;
    });
    this.items[index].disabled = false;
    this.activeIndex = index;
    await this.init();
    this.showstep = true;
  }

  closeticket(ticket) {
    this.editticket = Object.assign({}, ticket);
    this.editticket.id = null;
    this.editticket.comment = null;
    this.items.forEach((item) => {
      item.disabled = true;
    });
    this.editticket.ticket_type = 5;
    this.update.emit(this.editticket);
    return;
  }

  showProviderCard(t_provider_id) {
    this.provider_id.emit(t_provider_id);
    this.case_service_id.emit(this.service_id);
    this.showProviderDialog = true;
  }

  hideProviderCard() {
    this.showProviderDialog = false;
    this.provider_id.emit(null);
    this.case_service_id.emit(null);
  }

  selectProvider(provider, all = false) {
    this.Provider_new = provider;
    if (all) {
      this.editprovider = _.find(
        this.providersAll,
        (p) => p.id === provider.id
      );
    } else {
      this.editprovider = _.find(this.providers, (p) => p.id === provider.id);
    }
    this.editticket.provider_id = provider.provider_id;
    this.editticket.provider_site_id = provider.provider_site_id;
    this.editticket.coverage_id = provider.coverage_id;
    this.editticket.provider_status = 1;

    if (provider.assistancePrice_id) {
      this.editticket.assistancePrice_id = provider.assistancePrice_id;
      this.editticket.stateName = provider.state;
      this.editticket.cityName = provider.city;
    } else {
      this.editticket.assistancePrice_id = null;
      this.editticket.stateName = null;
      this.editticket.cityName = null;
    }

    this.providers.forEach((p) => {
      p.select = false;
    });
    provider.select = true;
    this.fieldsRequired['provider'] = false;

    setTimeout(() => {
      if (this.editprovider.lat && this.editprovider.lng) {
        const location = {
          latitude: this.editprovider.lat,
          longitude: this.editprovider.lng,
        };
        this.providerLocation.emit(location);
      }
    }, 500);
  }

  onSubmit() {
    alert('llamando a onsubmit');
  }

  setTickettype(editticket) {
    if (this.activeIndex === 0) editticket.ticket_type = 1;
    else if (this.activeIndex === 1) editticket.ticket_type = 2;
    else if (this.activeIndex === 2) editticket.ticket_type = 3;
    else if (this.activeIndex === 3) editticket.ticket_type = 4;
  }

  translateTypes() {
    const labels = this.typesService.getTypeLabels(this.types);

    if (labels.length === 0) {
      return;
    }
    // Translate all labels
    this.translate.get(labels).subscribe((trans: string[]) => {
      for (let i = 0; i < labels.length; i++) {
        const label = labels[i];

        if (this.types[i].label) {
          this.types[i].label = trans[label];
        }
      }

      this.updateItems();
    });
  }

  updateItems() {
    if (this.items.length >= 4) {
      this.items[0].label = this.types[0].label;
      this.items[1].label = this.types[1].label;
      this.items[2].label = this.types[2].label;
      this.items[3].label = this.types[3].label;

      // Update the missing item that is not in types
      this.translate.get(this.items[4].label).subscribe((res: string) => {
        this.items[4].label = res;
      });
    }
  }

  getContactPhones(contactPhones) {
    if (contactPhones == null) {
      return [];
    }

    return contactPhones.split(',');
  }

  step1SetLocation(location) {
    this.editticket.latitude = location.latitude;
    this.editticket.longitude = location.longitude;
  }

  step1SelectMap() {
    if (this.editprovider.lat && this.editprovider.lng) {
      const location = {
        latitude: this.editprovider.lat,
        longitude: this.editprovider.lng,
      };
      setTimeout(() => {
        this.providerLocation.emit(location);
      }, 500);
    }
  }

  hideProviderUsers() {
    this.is_visible = true;
    this.is_confirmation_visible = false;
    this.showProviderUserDialog = false;
  }

  showProviderUsers(provider) {
    this.onSelectProvider(provider);
    let users = provider.users;
    this.providers_app.emit(users);
    this.provider_app.emit(provider);
    this.case_id.emit(this.assistancecase.id);
    this.is_case_normal.emit(this.isNormalCase);
    this.is_visible = true;
    this.is_confirmation_visible = false;
    this.showProviderUserDialog = true;
  }

  onCancel() {
    this.showstep = false;
  }

  onSelectedUserProvider(isDone) {
    this.hideProviderUsers();
    if (isDone == true) {
      this.setUserProvider.emit(true);
    }
  }

  closeConfirm(close) {
    this.is_visible = close;
    this.is_confirmation_visible = !close;
  }

  formcartaau() {
    this.cartas = true;
  }

  Generarcarta() {
    this.activateemail = true;

    const filter = Object.assign({}, this.filter);
    filter['case_id'] = this.assistancecase.id;
    filter['nombre_titular'] = this.titular_name;
    filter['telefono'] = this.tel;
    filter['namepatient'] = this.namepatient;
    filter['identificationnumber'] = this.identificationnumber;
    filter['description'] = this.description;
    filter['coordinatedby'] = this.coordinatedby;
    filter['daynhour'] = this.daynhour;
    filter['branch'] = this.branch;
    filter['responsible'] = this.responsible;
    filter['cost'] = this.cost;
    filter['observation'] = this.observation;
    filter['usuario_asesor'] = this.usuario_asesor;
    filter['tipo_servicio'] = this.tipo_servicio;

    this.api.assistancecases
      .createletter()
      .filter(filter)
      .promise()
      .then((users) => {
        this.messageService.add({
          severity: 'info',
          summary: 'Info',
          detail: 'Carta Creada',
        });
      })
      .catch((e) => {
        let apiError = '';

        try {
          let err = JSON.parse(e._body);
          apiError = err.error;
        } catch (e) {
          apiError = '';
        }

        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `${e.error} ${apiError}`,
        });
      });
  }

  Enviarcartaprov() {
    this.cartas = true;
    this.emails = this.emails;
    
    const filter = Object.assign({}, this.filter);
    filter['correos'] = this.emails;
    filter['case_id'] = this.assistancecase.id;
    filter['nombre_titular'] = this.titular_name;
    filter['telefono'] = this.tel;
    filter['namepatient'] = this.namepatient;
    filter['identificationnumber'] = this.identificationnumber;
    filter['description'] = this.description;
    filter['coordinatedby'] = this.coordinatedby;
    filter['daynhour'] = this.daynhour;
    filter['branch'] = this.branch;
    filter['responsible'] = this.responsible;
    filter['cost'] = this.cost;
    filter['observation'] = this.observation;
    filter['usuario_asesor'] = this.usuario_asesor;
    filter['tipo_servicio'] = this.tipo_servicio;
    this.api.assistancecases
      .sendletteremail()
      .filter(filter)
      .promise()
      .then((users) => {
        this.messageService.add({
          severity: 'info',
          summary: 'Info',
          detail: 'Carta Enviada',
        });
      })
      .catch((e) => {
        let apiError = '';

        try {
          let err = JSON.parse(e._body);
          apiError = err.error;
        } catch (e) {
          apiError = '';
        }

        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `${e.error} ${apiError}`,
        });
      });
  }
  enviarcartaclie() {
    
  }

  onSelectday(date) {
    if (date === null) {
      this.fieldsRequired['programdate'] = true;
    } else {
      const set_date = date + ' ' + this.programtime;
      this.editticket.programdate = moment(set_date).toDate();
      this.fieldsRequired['programdate'] = false;
    }
  }

  test(provider) {
    
  }

  onSelectProvider(provider, all = false) {
    let idProviderSelected = provider.id;
    if (this.idProviderSelected == idProviderSelected) {
      this.idProviderSelected = null;
      this.editticket.provider_id = null;
      this.editticket.provider_site_id = null;
      this.editticket.coverage_id = null;
      this.editticket.provider_status = null;
      this.editticket.assistancePrice_id = null;
      this.editticket.cityName = null;
      this.editticket.stateName = null;
    } else {
      this.idProviderSelected = idProviderSelected;
      this.selectProvider(provider, all);
      // Para agregar la reassignacion de buca
      this.address = provider.provider_site.address
        ? provider.provider_site.address
        : provider.provider.address;
      this.onSetSiteUsers(provider.provider_site);
    }
  }

  showModalOutOfNetworkProvider() {
    this.editOutNetworkProvider = {};
    this.showNewDialog = true;
  }

  onSubmitOutOfNetworkProvider() {
    this.showNewDialog = false;

    let comment = '';
    this.editticket.provider_status = 3;

    if (this.editOutNetworkProvider.comment) {
      comment = this.editOutNetworkProvider.comment;
      this.editOutNetworkProvider.comment = '';
    }

    if (this.editOutNetworkProvider.name) {
      this.editOutNetworkProvider.comment +=
        'nombre: ' + this.editOutNetworkProvider.name + ' ';
    }
    if (this.editOutNetworkProvider.phone) {
      this.editOutNetworkProvider.comment +=
        'Teléfono: ' + this.editOutNetworkProvider.phone + ' ';
    }
    if (this.editOutNetworkProvider.service) {
      this.editOutNetworkProvider.comment +=
        'Servicio: ' + this.editOutNetworkProvider.service + ' ';
    }
    if (this.editOutNetworkProvider.cost) {
      this.editOutNetworkProvider.comment +=
        'Costo: ' + this.editOutNetworkProvider.cost + ' ';
    }
    if (this.editOutNetworkProvider.headquartersAddress) {
      this.editOutNetworkProvider.comment +=
        'Dirección Sede: ' +
        this.editOutNetworkProvider.headquartersAddress +
        ' ';
    }

    if (comment) {
      this.editOutNetworkProvider.comment += 'Comentario: ' + comment;
    }

    this.onSubmit();
  }

  onSelectAssignProvider() {
    this.flagAssignProvider = true;
    this.notifyAssignProviderView.emit(true);
  }

  goToBack() {
    this.flagAssignProvider = false;
    this.notifyAssignProviderView.emit(false);
  }

  openLinkLocationCustomer() {
    let url = `https://www.google.com/maps/place/${this.caseLocation.latitude},${this.caseLocation.longitude}`;
    this.api.copyToClipboard(url);
    this.messageService.add({
      severity: 'info',
      summary: 'Info',
      detail: 'Link de la localización del cliente copiado al portapapeles.',
    });
  }

  copyText(text) {
    this.api.copyToClipboard(text);
    this.messageService.add({
      severity: 'info',
      summary: 'Info',
      detail: 'Teléfono del cliente copiado al portapapeles.',
    });
  }

  seeMoreProvider() {
    this.showSeeMoreProviders = true;
  }
  

  loadMoreProviders() {
    this.hasMoreProviders = false
    if (this.page > Math.ceil(this.maxScroll)){
      this.hasMoreProviders = false
      this.isLoading = false
      this.noMoreProviders = true
      return
    }
    this.isLoading = true
    this.page++

    let case_providers 
    this.api.assistanceProvicerSites
      .v2get(this.country_id, this.ticket_service.service_id)
      .page(this.page)
      .filter({lat: this.caseLocation.latitude, lng: this.caseLocation.longitude, polygon_filter: this.polygonFilter})
      .promise().then(response => {
        case_providers = response
        let providers_app
        this.api.assistanceProvicerSites
          .getApp(
            this.country_id,
            this.ticket_service.service_id,
            this.assistancecase.id
          )
          .promise().then(response => {
            providers_app = response
            this.addProvidersFromResponse(case_providers, providers_app)
          });
      });
  }
  providerCtrl = new FormControl('');
  providerList: any[] = []; 
  filteredProviders: any;


  

  getProviders() {
    this.loaderService.display(true);
    let filter = {};
    if (this.state_id) filter['state_id'] = this.state_id;
    if (this.state_district_id) filter['district_id'] = this.state_district_id;
    if (this.searchProvider) filter['provider'] = this.searchProvider;
    if (this.polygonFilter) filter['polygon_filter'] = this.polygonFilter;
    if (this.caseLocation.latitude) filter['lat'] = this.caseLocation.latitude;
    if (this.caseLocation.longitude) filter['lng'] = this.caseLocation.longitude;
    
    this.api.assistanceProvicerSites
      .v2get(this.country_id, this.ticket_service.service_id)
      .filter(filter)
      .page(this.page)
      .promise()
      .then((caseProviders) => {
        if (caseProviders.count == 0) {
          this.translate.get('No providers found').subscribe((res: string) => {
            this.messageService.add({
              severity: 'info',
              summary: 'Info',
              detail: res,
            });
          });
        }
        this.setProvidersFromResponseall(caseProviders);
      })
      .catch((e) => {
        this.loaderService.display(false);
        this.translate
          .get('An error occurred while getting providers')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: res,
            });
          });
      });
      this.isLoading = false
  }

  onSelectState(state_id) {
    if (state_id) {
      const filter = { state_id: state_id };
      this.api.statedistricts
        .get()
        .filter(filter)
        .promise()
        .then((d) => {
          this.statesDistrict = d.data;
        });
    } else {
      this.statesDistrict = [];
    }
  }

  onSelectCountry(country_id) {
    if (country_id) {
      this.api.states
        .get(country_id)
        .promise()
        .then((states) => {
          this.states = states;
        });
    } else if (country_id == 0) {
      this.state_id = null;
      this.state_district_id = null;
    }
  }

  //---metodo para reasignar proveedor
  async Generar() {
    let buca_action = null;
    if (this.assistance_plan_service?.buca_apply == 1) {
      this.loaderService.display(true);

      const response = await this.verifyBucaCase();
      this.loaderService.display(false);

      if (response == 2) return;
      else if (response == -1) {
        this.buca_message.emit({
          status_buca: 'error',
          summary: 'Resultado',
          message: 'Error en la validación del caso con BUCA.',
        });

        return;
      } else if (response == 1) buca_action = 3; // Accion relacionada a Buca: 3 - Reasignar caso
    }
    // HACER VALIDACION SI UN CASO YA SE ENCUENTRA EN CURSO EN EL MODULO DE SINIESTROS
    let sinister_action = 3;
    const filter = Object.assign({}, this.filter);
    filter['case_id'] = this.case_id_input;
    filter['Provider_new'] = this.Provider_new.provider_id;
    filter['Provider_site_new'] = this.Provider_new.provider_site_id;
    filter['Provider_coverage_new'] = this.Provider_new.coverage_id;

    if (this.sds_provider && this.buca_plan_service) {
      if (!this.new_provider_id) {
        this.buca_message.emit({
          status_buca: 'error',
          summary: 'Resultado',
          message: 'Odontólogo requerido',
        });

        return;
      }

      if (!this.appointmentDate) {
        this.buca_message.emit({
          status_buca: 'error',
          summary: 'Resultado',
          message: 'Fecha de cita es requerida',
        });

        return;
      }

      if (!this.address) {
        this.buca_message.emit({
          status_buca: 'error',
          summary: 'Resultado',
          message: 'Dirección del proveedor es requerida',
        });

        return;
      }

      filter['assistance_provider_user_id'] = this.new_provider_id;
      filter['programdate'] = this.appointmentDate;
      filter['appointment_date'] = this.appointmentDate;
      filter['buca_action'] = buca_action;
      filter['provider_address'] = this.address;

      this.assistancecase.appointment_date = this.appointmentDate;
    }
    if (this.assistance_plan_service?.sinister_apply == 1) {
      filter['assistance_provider_user_id'] = this.new_provider_id;
      filter['programdate'] = this.appointmentDate;
      // HACER VALIDACION SI UN CASO YA SE ENCUENTRA EN CURSO EN EL MODULO DE SINIESTROS
      filter['sinister_action'] = sinister_action;
      
    }
  
    this.loaderService.display(true);

    this.api.assistancecases
      .reassignprovider()
      .filter(filter)
      .promise()
      .then((users) => {
        if (users.error) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `${users.msg}`,
          });
          this.buca_message.emit({
            status_buca: 'error',
            summary: 'Error',
            message: users.msg,
          });
          this.loaderService.display(false);
        } else {
          if (this.sds_provider && this.buca_plan_service) {
            if (users.length > 1) {
              let index = -1;
              users.map((value, index_) => {
                if ('status_buca' in value) {
                  this.buca_message.emit(value);
                  index = index_;
                }
              });
              if (index != -1) users.splice(index, 1);
            }
          }

          this.creatticket = _.cloneDeep(this.grouptickets[0]);
          this.creatticket = Object.assign({}, this.grouptickets[0]);
          this.creatticket.ticket_type = 9;
          this.creatticket.case_id = Number(this.case_id_input);
          this.creatticket.user_id = Number(this.user_id);

          if (
            this.creatticket == null ||
            this.creatticket.provider_status != 1
          ) {
            //--si tiene provider null pongo que reasigno
            this.creatticket.comment =
              'El usuario ' +
              this.me.user.name +
              ' reasigno al proveedor ' +
              this.Provider_new?.provider_site?.name +
              ' por la razon de:  ' +
              this.reason_select +
              '. ' +
              this.comment;
          } else {
            
            this.creatticket.comment =
              'El usuario ' +
              this.me.user.name +
              ' desasigno al proveedor ' +
              this.creatticket.provider.name +
              ' y ' +
              ' reasigno al proveedor ' +
              this.Provider_new?.provider_site?.name +
              ' por la razon de:  ' +
              this.reason_select +
              '. ' +
              this.comment;
          }
          this.messageService.clear();
          this.api.assistancetickets
            .create(this.creatticket)
            .promise()
            .then((tickets) => {
              this.translate
                .get('Assistance ticket created')
                .subscribe((res: string) => {
                  
                  this.messageService.add({
                    severity: 'info',
                    summary: 'Info',
                    detail: `${res}`,
                  });
                });
              this.loaderService.display(false);

              window.location.reload();
            })
            .catch((e) => {
              const errmsg = JSON.parse(e['_body']);
              
              this.translate
                .get('Error creating new assistance tiket')
                .subscribe((res: string) => {
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: `${res}: ${e.statusText} ${errmsg['error']}`,
                  });
                });
              this.loaderService.display(false);
            });

          this.loaderService.display(false);
        }
      })
      .catch((e) => {
        
        this.loaderService.display(false);
        let error_msg = '';
        try {
          error_msg = e.error.error;
          this.translate.get(error_msg).subscribe((res: string) => {
            error_msg = res;
          });
        } catch {
          error_msg = e.error;
        }
        this.buca_message.emit({
          status_buca: 'error',
          summary: 'Error',
          message: error_msg,
        });
      });
  }

  verifyBucaCase(): Promise<number> {
    return new Promise((resolve, reject) => {
      this.api.buca
        .verifyBucaCase(this.editticket.case_id)
        .promise()
        .then((response) => {
          if (response['status'] == 2) {
            this.buca_message.emit({
              status_buca: 'error',
              summary: 'Resultado',
              message:
                'Ya se inició la atención en el portal BUCA por lo que el caso no se puede reasignar.',
            });
          }

          resolve(response['status']);
        })
        .catch((error) => {
          reject(-1);
        });
    });
  }
  verifySinisterCase(): Promise<number> {
    return new Promise((resolve, reject) => {
      this.api.sds
        .verifySinisterCase(this.editticket.case_id)
        .promise()
        .then((response) => {
          if (response['status'] == 2) {
            this.buca_message.emit({
              status_buca: 'error',
              summary: 'Resultado',
              message:
                'Ya se inició la atención en el portal de Siniestros por lo que el caso no se puede reasignar.',
            });
          }

          resolve(response['status']);
        })
        .catch((error) => {
          reject(-1);
        });
    });
  }

  //---metodo para retroceder a la vista principal
  hidereasigncard() {
    this.ocultar.emit(true);
  }
  // Para agregar la reassignacion de buca
  onSetSiteUsers(site) {
    this.appointmentDate = null;
    this.new_provider_id = null;
    this.comment = null;
    if (this.editticket.provider_id) {
      this.loaderService.display(true);
      this.api.provider_site_users
        .get(site.id)
        .promise()
        .then((users) => {
          this.siteUsers = users.sort((a, b) => {
            const nameA = a.name.toLowerCase();
            const nameB = b.name.toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });
          this.loaderService.display(false);
        });
    }
  }
  
normalizeText(text: string): string {
  return (text || '')
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]/g, '')
}
normalizePhoneArray(phones: string[] | undefined): string[] {
  if (!phones || !Array.isArray(phones)) return [];
  return phones.map(phone => this.normalizeText(phone));
}


  
   filterProviders(value: string | any): any[] {
  const rawText = typeof value === 'string' ? value : value?.name || '';
  const normalizedInput = this.normalizeText(rawText);

  return this.providerList.filter(provider => {
    const fieldsToSearch = [
      this.normalizeText(provider.name || ''),
      this.normalizeText(provider.sap_code || ''),
      ...this.normalizePhoneArray(provider.phones_cabin),
      ...this.normalizePhoneArray(provider.phones_accounting),
      ...this.normalizePhoneArray(provider.phones_web),
      ...this.normalizePhoneArray(provider.contact_phones),
      this.normalizeText(provider.site_name || ''),
      ...this.normalizePhoneArray(provider.site_cabin_phones),
    ];

    return fieldsToSearch.some(field => field.includes(normalizedInput));
  });
}

  async activatePolygonFilter() {
    this.polygonFilter = !this.polygonFilter;

    this.page = 1;
    this.loaderService.display(true);
    let case_providers = await this.api.assistanceProvicerSites
      .v2get(this.country_id, this.ticket_service.service_id)
      .page(this.page)
      .filter({lat: this.caseLocation.latitude, lng: this.caseLocation.longitude, polygon_filter: this.polygonFilter})
      .promise();
    let providers_app = await this.api.assistanceProvicerSites
      .getApp(
        this.country_id,
        this.ticket_service.service_id,
        this.assistancecase.id
      )
      .promise();
    this.loaderService.display(false);
    this.setProvidersFromResponse(case_providers, providers_app);
  }  

  onProviderHover(provider: any) {
    if (!provider || !provider.provider_polygons || provider.provider_polygons.length === 0) {
      return;
    }

    this.clearProviderPolygons();

    this.drawProviderPolygons(provider);
    this.currentHoveredProviderId = provider.id;
  }

  onProviderHoverOut(provider: any) {
    if (!provider || this.currentHoveredProviderId !== provider.id) {
      return;
    }

    this.clearProviderPolygons();
    this.currentHoveredProviderId = null;
  }

  private drawProviderPolygons(provider: any): void {
    if (!provider.provider_polygons || !Array.isArray(provider.provider_polygons)) {
      return;
    }

    if (!this.providersMap) {
      console.warn('Mapa no disponible para dibujar polígonos');
      return;
    }

    const polygons: google.maps.Polygon[] = [];

    provider.provider_polygons.forEach((polygonData: any) => {
      try {
        const coordinates = JSON.parse(polygonData.polygon_coordinates);

        if (!Array.isArray(coordinates) || coordinates.length < 3) {
          console.warn('Polígono inválido:', polygonData);
          return;
        }

        const polygon = new google.maps.Polygon({
          paths: coordinates,
          fillColor: polygonData.color || '#FF5722',
          fillOpacity: (polygonData.fill_opacity || 50) / 100,
          strokeColor: polygonData.color || '#FF5722',
          strokeWeight: polygonData.stroke_weight || 2,
          strokeOpacity: 0.8,
          map: this.providersMap // Usar la referencia correcta al mapa
        });

        polygons.push(polygon);

      } catch (error) {
        console.error('Error al dibujar polígono:', error, polygonData);
      }
    });

    this.providerPolygons.set(provider.id, polygons);
  }

  private clearProviderPolygons(): void {
    this.providerPolygons.forEach((polygons, providerId) => {
      polygons.forEach(polygon => {
        polygon.setMap(null);
      });
    });
    this.providerPolygons.clear();
  }

}
